import { CategoryProps } from 'strapi/component/categoryList/types';
import { collectImageComponentParams } from 'strapi/component/shared/collector';
import { ReactComponentType } from 'strapi/component/types';
import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import CategoryList from './CategoryList';

export const collectCategoryListParams = (
  pageType: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof CategoryList> | undefined => {
  if (
    pageType === PageType.CreateLibraryPage &&
    'categoryList' in page &&
    !!page.categoryList &&
    !!page.categoryList.categoriesInfo
  ) {
    const categories: CategoryProps[] = page.categoryList.categoriesInfo.map(
      (x) => ({
        name: x.category.name,
        description: x.description,
        items: x.category.use_cases
          ?.filter((y) => y && y.name && y.create_use_case_page?.path)
          ?.map((y) => ({
            title: y.name,
            url: y.create_use_case_page.path,
            image: collectImageComponentParams(y.create_use_case_page.cover)!,
          })),
        icon: x.icon,
      })
    );

    return {
      component: ReactComponentType.CategoryList,
      props: {
        withNavigation: page.categoryList.withNavigation ?? false,
        backgroundColor: page.categoryList.backgroundColor,
        categories: categories,
      },
    };
  }

  if (
    pageType === PageType.ToolsLibraryPage &&
    'toolsCategoryList' in page &&
    !!page.toolsCategoryList &&
    !!page.toolsCategoryList.toolsCategoriesInfo
  ) {
    const categories: CategoryProps[] =
      page.toolsCategoryList.toolsCategoriesInfo.map((x) => {
        return {
          name: x.name,
          description: x.description,
          items: x.enrichedItems,
          icon: x.icon,
        };
      });

    return {
      component: ReactComponentType.CategoryList,
      props: {
        withNavigation: page.toolsCategoryList.withNavigation ?? false,
        backgroundColor: page.toolsCategoryList.backgroundColor,
        categories: categories,
      },
    };
  }

  return undefined;
};
